import React, { useEffect, useState } from "react";
import { deletePost, getAdminPosts } from "../../services/postServices";
import { NavLink } from "react-router-dom";
import api from "../../services/api";

const Allpost = () => {
  const [postData, setPostData] = useState([]);

  const fetchPost = async () => {
    try {
      const response = await getAdminPosts();
      setPostData(response);
    } catch (err) {
      console.error("Failed to fetch post", err);
    }
  };

  const handleDelete = async (postId) => {
    try {
      if (window.confirm("Are you sure you want to delete the post?")) {
        await deletePost(postId);
        setPostData((prevPosts) =>
          prevPosts.filter((post) => post.id !== postId)
        );
      }
    } catch (err) {
      console.error("Failed to delete post.", err);
    }
  };

  useEffect(() => {
    fetchPost();
  }, []);

  return (
    <section className="container-fluid mt-4">
      {/* Page Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>All Posts</h1>
        <button className="btn btn-primary">
          <NavLink
            to="/dashboard/addNewPost"
            className="text-light text-decoration-none"
          >
            <i className="bi bi-plus-circle me-2"></i>New Post
          </NavLink>
        </button>
      </div>

      {/* Posts List */}
      <div className="row">
        {postData.map((post) => (
          <div key={post.id} className="col-12 mb-4">
            <article className="card h-100 shadow-sm">
              <div className="row g-0">
                {/* Left side (Image) */}
                <div className="col-md-2">
                  <img
                    src={`${api.defaults.baseURL.replace("/api", "")}/uploads/${
                      post.image1
                    }`}
                    alt={post.title}
                    className="img-fluid rounded-start w-100 h-100"
                    style={{ objectFit: "cover" }}
                  />
                </div>

                {/* Right side (Content) */}
                <div className="col-md-10">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <h3 className="card-title h5">{post.title}</h3>

                    <p className="card-text">
                      {post.content.substring(0, 150)}...
                    </p>

                    <p className="card-text">
                      <small className="text-muted">
                        Category: {post.category ? "painting" : "tailing"}
                      </small>
                    </p>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <span
                        className={`badge ${
                          post.status ? "bg-success" : "bg-warning"
                        }`}
                      >
                        {post.status ? "Published" : "Draft"}
                      </span>

                      <div className="btn-group" role="group">
                        <NavLink
                          to={`/dashboard/editPost/${post.id}`}
                          className="btn btn-outline-primary btn-sm text-decoration-none"
                        >
                          <i className="bi bi-pencil me-1"></i>Edit
                        </NavLink>
                        <button
                          onClick={() => handleDelete(post.id)}
                          className="btn btn-outline-danger btn-sm"
                        >
                          <i className="bi bi-trash me-1"></i>Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Allpost;
